import {ValueObject} from '@s-ui/domain'

import {FilterStringSearchValueObject} from './FilterStringSearchValueObject.js'

export class FilterModelSearchValueObject extends ValueObject {
  #id
  #name

  constructor({id, name}) {
    super()
    this.#id = id
    this.#name = name
  }

  static create({id, name}) {
    return new FilterModelSearchValueObject({
      id: FilterStringSearchValueObject.create(id),
      name: FilterStringSearchValueObject.create(name)
    })
  }

  static createWithDefaultValue({config, id, name}) {
    const {DEFAULT_MODEL_SEARCH} = config.get('searchFilters')

    return new FilterModelSearchValueObject({
      id: FilterStringSearchValueObject.create({string: id ?? DEFAULT_MODEL_SEARCH.id}),
      name: FilterStringSearchValueObject.create({string: name ?? DEFAULT_MODEL_SEARCH.name})
    })
  }

  get value() {
    return {id: this.#id.value, name: this.#name.value}
  }

  toJSON() {
    return {
      id: this.#id.toJSON(),
      name: this.#name.toJSON()
    }
  }
}
